<template>
  <div class="content if-profile">
    <div class="md-layout if-profile-body">
      <SPIFProfileHeader  :headerData="this.headerData"/>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 mt-4">
        <div class="navbar md-toolbar md-transparent md-elevation-4 p-0">
          <h1 class="section_header">Cash Tables</h1>
          <!-- <div class="navbar md-toolbar md-transparent md-elevation-4">
            <div class="md-toolbar-section-start">
              <div>
                <h1 class="md-title profile-title">Sources &amp; Uses of Funds</h1>
              </div>
            </div>
          </div> -->

          <div class="md-toolbar-row fundamentals_wpr profit-loss p-0">
            <div class="md-card-nav-tabs">
              <div class="md-toolbar-row fundamentals_area p-0 m-0">
                <nav-tabs-card no-label md-elevation="0">
                  <template slot="content">
                    <md-tabs md-alignment="left" class="p-0">
                      <md-tab
                        id="tab-money"
                        md-label="Percentages"
                        md-icon="percent"
                        class="p-0"
                      >
                        <div class="md-layout">
                          <div class="md-layout-item p-0">
                            <md-card-header>
                              Percentages
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                >
                                  <md-table
                                    v-model="tableAnnualCashRatiosPercent"
                                    table-header-color="blue"
                                    class="profit-and-loss-table"
                                  >
                                    <md-table-row
                                      slot="md-table-row"
                                      slot-scope="{ item }"
                                    >
                                      <md-table-cell md-label="Annual Cash Ratios" class="md-table-side-label">
                                        {{ item.name }}
                                        <md-tooltip md-direction="bottom">{{
                                          item.rollover
                                        }}</md-tooltip>
                                      </md-table-cell>

                                      <md-table-cell md-label="Trend" class="table_chart">
                                        <chart-card
                                          header-animation="false"
                                          :chart-data="colouredLineChart.data"
                                          :chart-options="colouredLineChart.options"
                                          chart-type="Line"
                                          header-icon
                                          chart-inside-content
                                          no-footer
                                          background-color="blue"
                                        >
                                        </chart-card>
                                      </md-table-cell>

                                      <md-table-cell
                                        v-for="key in Object.keys(item.dates)"
                                        :key="key"
                                        :md-label="key"
                                        >{{ item.dates[key] }}%
                                      </md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </div>
                        </div>
                      </md-tab>
                      <md-tab
                        id="tab-payments"
                        md-label="Dollars"
                        md-icon="payments"
                        class="p-0"
                      >
                        <div class="md-layout">
                          <div class="md-layout-item md-size-100 p-0">
                            <md-card class="m-0">
                              <md-card-header>
                                Dollars
                              </md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div class="md-layout-item md-medium-size-100 md-size-100 p-0 border-0">
                                    <md-table
                                      v-model="tableAnnualCashRatiosDollar"
                                      table-header-color="blue"
                                      class="profit-and-loss-table"
                                    >
                                      <md-table-row
                                        slot="md-table-row"
                                        slot-scope="{ item }"
                                      >
                                        <md-table-cell md-label="Annual Cash Ratios" class="md-table-side-label">
                                          {{ item.name }}
                                          <md-tooltip md-direction="bottom">{{
                                            item.rollover
                                          }}</md-tooltip>
                                        </md-table-cell>

                                        <md-table-cell md-label="Trend" class="table_chart">
                                          <chart-card
                                            header-animation="false"
                                            :chart-data="colouredLineChart.data"
                                            :chart-options="colouredLineChart.options"
                                            chart-type="Line"
                                            header-icon
                                            chart-inside-content
                                            no-footer
                                            background-color="blue"
                                          >
                                          </chart-card>
                                        </md-table-cell>

                                        <md-table-cell
                                          v-for="key in Object.keys(item.dates)"
                                          :key="key"
                                          :md-label="key"
                                          >${{ item.dates[key] }}
                                        </md-table-cell>
                                      </md-table-row>
                                    </md-table>

                                    <md-table
                                      v-model="worksheet"
                                      table-header-color="blue"
                                      class="sources-users-table"
                                    >
                                      <md-table-row
                                        slot="md-table-row"
                                        slot-scope="{ item }"
                                      >
                                        <md-table-cell md-label="Worksheet">{{
                                          item.title
                                        }}</md-table-cell>

                                        <md-table-cell md-label="Trend" class="table_chart">
                                          <chart-card
                                            header-animation="false"
                                            :chart-data="colouredLineChart.data"
                                            :chart-options="colouredLineChart.options"
                                            chart-type="Line"
                                            header-icon
                                            chart-inside-content
                                            no-footer
                                            background-color="blue"
                                          >
                                          </chart-card>
                                        </md-table-cell>

                                        <md-table-cell
                                          v-for="key in Object.keys(item.dates)"
                                          :key="key + 'worksheet'"
                                          :md-label="key"
                                          >{{ item.dates[key] }}</md-table-cell
                                        >
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                        </div>
                      </md-tab>
                    </md-tabs>
                  </template>
                </nav-tabs-card>
              </div>
            </div>
            <div class="extra_info_area neg_topMargin">
              <!-- <md-card>
                <md-card-header><md-icon>account_balance</md-icon>Curabitur Eleifend</md-card-header>
                <md-card-content>
                  <h4>Praesent venenatis</h4>
                  <p>Sed et placerat lorem. Integer nec accumsan tortor. Nullam at eleifend urna. Donec pulvinar quam ligula, id tincidunt orci rutrum ut.</p>
                  <h4>Quisque ut ex ligula</h4>
                  <p>Nullam vel pulvinar nisl. Morbi aliquam scelerisque congue. Quisque ut ex ligula. Nunc eu nunc in nulla pulvinar efficitur non id leo. Praesent eget sem eget eros mattis malesuada.</p>
                </md-card-content>
              </md-card>-->
              <!-- <md-card>
                <md-card-header><md-icon>vertical_split</md-icon>Vivamus Hendrerit</md-card-header>
                <md-card-content>
                  <h4>Fusce feugiat mollis</h4>
                  <p>Sed et placerat lorem. Integer nec accumsan tortor. Nullam at eleifend urna. Donec pulvinar quam ligula, id tincidunt orci rutrum ut.</p>
                  <h4>Praesent eget sem eget</h4>
                  <p>Nullam vel pulvinar nisl. Morbi aliquam scelerisque congue. Quisque ut ex ligula. Nunc eu nunc in nulla pulvinar efficitur non id leo. Praesent eget sem eget eros mattis malesuada.</p>
                </md-card-content>
              </md-card> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NavTabsCard, ChartCard } from '@/components';
import { mapState } from 'vuex';
import SPIFProfileHeader from './_partials/SPIFProfileHeader.vue';
import formatData from '@/mixins/format-data';

export default {
  components: {
    ChartCard,
    SPIFProfileHeader,
    NavTabsCard,
  },
  mixins: [formatData],
  props: ['headerData'],
  data() {
    return {
      colouredLineChart: {
        data: {
          labels: [1, 2, 3, 4, 5],
          series: [
            [1, 5, 3, 4, 2]
          ]
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 1,
          }),
          chartPadding: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
          },
          axisY: {
            showGrid: false,
            showLabel: false,
            offset: 0,
          },
          axisX: {
            showGrid: false,
            showLabel: false,
            offset: 0,
            scaleMinSpace: 6
          },
          showPoint: true,
          showLabel: false,
          width: "100px",
          height: "25px",
          seriesBarDistance: 10,
          fullWidth: true,
        },
      },
      changein: [],
      worksheet: [],
      tableAnnualCashRatiosDollar: [],
      tableAnnualCashRatiosPercent: [],
      display_source_uses: false,
    };
  },
  computed: {
    ...mapState({
      data: (state) => state.user.profile.data.data,
      // sourcesUses: (state) => state.user.report.data['sourcesUses'],
      // years: (state) => state.user.report.data['sourcesUses']['years'],
      showYears: (state) => state.user.profile.data.showYears,
      annualCashRatiosDollar: (state) =>
        state.user.profile.data.tables.annual_cash_ratios_dollar,
      annualCashRatiosPercent: (state) =>
        state.user.profile.data.tables.annual_cash_ratios_percent,
      report: (state) => state.user.profile.data,
    }),
  },
  mounted() {
    let filtered_years = [];
    Object.keys(this.showYears).forEach((k, i) => {
      if (this.showYears[k] && this.years) {
        filtered_years.push(this.years[i]);
      }
    });
    if (!filtered_years.length) {
      filtered_years = this.years;
    }

    this.tableAnnualCashRatiosDollar = this.formatTable(
      this.annualCashRatiosDollar,
      'industry',
      'dollar'
    );
    this.tableAnnualCashRatiosDollar = this.tableAnnualCashRatiosDollar.map(
      (item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return filtered_years && !filtered_years.includes(fItem);
        });
        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      }
    );

    this.tableAnnualCashRatiosPercent = this.formatTable(
      this.annualCashRatiosPercent,
      'industry',
      'percent'
    );
    this.tableAnnualCashRatiosPercent = this.tableAnnualCashRatiosPercent.map(
      (item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return filtered_years && !filtered_years.includes(fItem);
        });
        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      }
    );

    this.changein = this.changein.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });
    this.worksheet = this.worksheet.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });
  },
  methods: {
    formatData(table, data) {
      let getDates = (id) =>
        this.years.reduce((acc, cur, index) => {
          let value = this.actualData[this.years.length - index - 1][id];

          value = isNaN(Number(value)) ? value : Number(value.toFixed(0));

          return { ...acc, [cur]: value };
        }, {});

      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },
  },
};
</script>
<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}
.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}
</style>
